// Shared invoice-PDF download helper.
// Consolidates the identical fetch -> blob -> anchor-click routine that was
// copy-pasted in Invoices.js, InvoiceView.js and BatchInvoices.js.
//
// Fetches the invoice PDF with the auth token, triggers a browser download, and
// throws on failure (caller shows the toast so per-page wording/spinners stay).

// The server names the file after the invoice reference in Content-Disposition,
// so read it from there instead of building a name here. That is what makes the
// download invoice-534.pdf rather than a name built from the database row id.
export function filenameFromHeader(header) {
  if (!header) return '';
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch (e) {
      /* fall through to the plain filename */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : '';
}

export async function downloadInvoicePdf(invoiceId, { filename, invoiceNumber } = {}) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL || ''}/api/invoices/${invoiceId}/generate-pdf`,
    { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
  );

  if (!response.ok) {
    let detail = 'Failed to download PDF';
    try {
      const data = await response.json();
      detail = data.detail || detail;
    } catch (e) {
      /* non-JSON error body */
    }
    throw new Error(detail);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download =
    filenameFromHeader(response.headers.get('Content-Disposition')) ||
    filename ||
    (invoiceNumber
      ? `invoice-${String(invoiceNumber).replace(/[^A-Za-z0-9._-]+/g, '-')}.pdf`
      : `invoice-${invoiceId}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
